import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { JssContextService } from '../jss-context.service';
import { JssState } from '../JssState';
import { PbJssLayoutService } from '../layout/pb-jss-layout.service';

export const jssRouteResolver: ResolveFn<JssState> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  // route params are created by custom route matcher in app-routing.module
  const jssService = inject(JssContextService);
  const pbJssLayoutService = inject(PbJssLayoutService);

  //return jssService.changeRoute(route.params.serverRoute, route.params.language);
  if (route.queryParams['sc_params']){
    pbJssLayoutService.$customParams.next(pbJssLayoutService.decodeCustomParams(route.queryParams['sc_params']));
  }
  // route params are created by custom route matcher in app-routing.module
  return jssService.changeRoute(route.params.serverRoute, route.params.language);
};
